var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-carousel',{attrs:{"autoplay":"","dots":false,"effect":"fade"}},[_c('a',{attrs:{"target":"_blank","href":"https://forms.gle/XMELu2bs2VrpsRhn7"}},[_c('img',{attrs:{"src":"/resources/images/banner/hotsale.2025.2.png"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }